import { PerformanceLabPlan, PerfLabOffer } from './types';
import { getCataloguePriceCutOffer } from './priceCut';

export const MONSOON_OFFER_ENDS = '2026-08-18T23:59:59+05:30';

const isOfferInWindow = (offer: PerfLabOffer, now: number): boolean => {
  if (offer.startsAt && now < new Date(offer.startsAt).getTime()) return false;
  if (offer.expiresAt && now >= new Date(offer.expiresAt).getTime()) return false;
  return true;
};

// Kept out of ./plans so importing it doesn't pull the 145KB plan catalogue.
export const getActivePlanOffer = (
  plan: PerformanceLabPlan,
): PerfLabOffer | null => {
  const now = Date.now();
  // The Oct–Nov festive cut (EXINPL15) wins over a standing offer (massage,
  // cryo) for the window, then that standing offer comes back. List prices
  // stay full; checkout attaches the discount code on the offer.
  const priceCut = getCataloguePriceCutOffer(plan.id);
  if (priceCut && isOfferInWindow(priceCut, now)) return priceCut;

  if (!plan.offer || !isOfferInWindow(plan.offer, now)) return null;
  return plan.offer;
};

/** Struck amount next to an active offer. Falls back to the catalogue list. */
export const getOfferStrikePrice = (
  plan: PerformanceLabPlan,
  offer: PerfLabOffer,
): number => offer.strikePrice ?? plan.price;
